export default 'androidwear';
